import { combineReducers } from 'redux';
import { commonState } from './common';
import { indexState } from './pageIndex';
// import { tlwIndexState } from './tlwIndex';
// import { headerState } from './header';
// import { footerState } from './footer';
// import { memberState } from './member';
import { productState } from './product';
// import { categoryState } from './category';
import { cartState } from './cart';
import { shoppingInfoState } from './shoppingInfo';
// import { flagshipState } from './flagship';
// import { instantProductState } from './instantProduct';
// import { searchPageState } from './searchPage';
import { orderListState } from './orderList';
import { orderDetailState } from './orderDetail';
import { promotionalMixState } from "./promotionalMix";
// import categoryChooseState from './categoryChoose';


export default combineReducers({
  commonState,
  indexState,
  // tlwIndexState,
  // headerState,
  // footerState,
  // memberState,
  productState,
  // categoryState,
  cartState,
  shoppingInfoState,
  // flagshipState,
  // instantProductState,
  // searchPageState,
  orderListState,
  orderDetailState,
  promotionalMixState,
  // categoryChooseState,

});
